import { List, Datagrid, TextField, NumberField, EditButton, ShowButton } from "react-admin";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouteId } from "@/utils/route-utility";

export const ProjectKarzanList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to manage Karzan.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "updatedAt", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="show">
        <TextField source="lenderName" emptyText="—" />
        <NumberField source="principalAmount" options={{ style: "currency", currency: "INR" }} />
        <NumberField source="repaidAmount" options={{ style: "currency", currency: "INR" }} />
        <TextField source="status" />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};
